import type { RootState } from '../../../../store';
import { selectMethaneLayerConfig, selectOGILayerConfig } from './mapLayerSelectors';

export const selectFeatureSelected = (state: RootState) => state.pages.emissions.selectedFeature;

// item id
export const selectVisualizedStacItemId = (state: RootState) =>
    selectFeatureSelected(state).selectedMethaneFeature.itemId;

// feature date
export const selectVisualizedFeatureDate = (state: RootState) =>
    selectFeatureSelected(state).selectedMethaneFeature.targetDate;

// feature's target id
export const selectVisualizedFeatureTargetId = (state: RootState) =>
    selectFeatureSelected(state).selectedMethaneFeature.targetId;

// feature coordinates
export const selectVisualizedFeatureCoordinates = (state: RootState) =>
    selectFeatureSelected(state).selectedMethaneFeature.coordinates;

// capture that is currently active. this is set through user interaction with a historical time selector
export const selectActiveCapture = (state: RootState) => selectFeatureSelected(state).activeCapture;

export const selectHighlightedFeature = (state: RootState) => {
    const layers = { ...selectMethaneLayerConfig(state), ...selectOGILayerConfig(state) };

    const layerWithHighlight = Object.values(layers).find((layer) => layer.highlightedObject);
    return layerWithHighlight?.highlightedObject || null;
};

export const selectHighlightedLayerId = (state: RootState) => {
    const layers = { ...selectMethaneLayerConfig(state), ...selectOGILayerConfig(state) };
    const layerWithHighlight = Object.entries(layers).find(([_key, layer]) => !!layer.highlightedObject);
    return layerWithHighlight?.[0] || null;
};

export const selectCoordinateFromHighlightedFeature = (state: RootState) => {
    let toReturn: number[] | undefined;
    const feature = selectHighlightedFeature(state);
    if (feature) {
        if ('coordinate' in feature) toReturn = feature.coordinate;
        else if ('coordinates' in feature.geometry) toReturn = feature.geometry.coordinates as number[] | undefined;
    }

    return toReturn;
};

export const selectEmissionsDrawerCardData = (state: RootState) => {
    return state.pages.emissions.selectedFeature.emissionsDrawerCardData;
};

export const selectUrlParamsInitialized = (state: RootState) =>
    state.pages.emissions.selectedFeature.urlParamsInitialized;
